import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from "../services/apiConfig";

function LocalHtmlComponent() {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    console.log("process.env.PUBLIC_URL : " + process.env.PUBLIC_URL)
    fetch('/hp0621/index.html')
      .then(response => response.text())
      .then(data => {
        setHtmlContent(data);
      });
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}

export default LocalHtmlComponent;




// import React, { useEffect, useState } from 'react';

// function LocalHtmlComponent() {
//   const [htmlContent, setHtmlContent] = useState('');

//   useEffect(() => {
//     fetch(process.env.PUBLIC_URL + '/local-file.html')
//       .then(response => response.text())
//       .then(data => {
//         setHtmlContent(data);
//       });
//   }, []);

//   return (
//     <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
//   );
// }